import React, {useState} from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {BackTo} from 'components/common/BackTo';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {Stepper} from 'components/ui-kit/Stepper';
import {ROUTE} from 'core/routes';
import {OrdersCreateGate, step$} from 'models/orders/create';

import {OrderForm} from './form';
import {Preview} from './preview';
import {OrderProducts} from './products';

export const CreateCustomerOrder = () => {
    const {t} = useTranslation();
    const step = useStore(step$);
    return (
        <>
            <BackTo to={ROUTE.ORDERS_GRID}>{t('pages.orders.back')}</BackTo>
            <ContentContainer>
                <h1>{t('pages.orders.newOrder')}</h1>
                <OrdersCreateGate />
                <Stepper
                    steps={[
                        {
                            label: t('pages.orders.stepOne'),
                            component: <OrderForm />,
                        },
                        {
                            label: t('pages.orders.stepTwo'),
                            component: <OrderProducts />,
                        },
                        {
                            label: t('pages.orders.stepThree'),
                            component: <Preview />,
                        },
                    ]}
                    activeStep={step}
                />
            </ContentContainer>
        </>
    );
};
